import { useState } from "react";
import axios from "axios";
import { X } from "lucide-react";
import { API_BASE } from "../apiBase";
import { useAuth } from "./AuthContext";
import LegalModals, { overlayStyle, modalStyle, closeBtnStyle } from "./LegalModals";

const API = API_BASE;
const TEAL = "var(--pord-teal, #9aada8)";

export default function AppFooter() {
    const { user, logout } = useAuth();
    const [showConfirm, setShowConfirm] = useState(false);
    const [busy, setBusy] = useState(false);
    const [msg, setMsg] = useState("");

    const handleUnsubscribe = async () => {
        setBusy(true);
        try {
            const { data } = await axios.post(`${API}/api/auth/unsubscribe`, {}, { withCredentials: true });
            setMsg(data.message);
            setTimeout(() => { logout(); window.location.href = "/"; }, 3000);
        } catch (err) {
            setMsg(err.response?.data?.detail || "Failed to unsubscribe");
        } finally {
            setBusy(false);
        }
    };

    return (
        <footer data-testid="app-footer" style={{
            padding: "32px 24px 24px", textAlign: "right",
            borderTop: "1px solid rgba(184,212,208,0.06)", marginTop: 40,
        }}>
            {/* Unsubscribe Modal */}
            {showConfirm && (
                <div style={overlayStyle} onClick={() => !busy && setShowConfirm(false)}>
                    <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
                        <button onClick={() => setShowConfirm(false)} style={closeBtnStyle}><X size={18} /></button>
                        {msg ? (
                            <p style={{ color: "#DAF2D0", fontSize: 14 }}>{msg}</p>
                        ) : (
                            <>
                                <p style={{ color: "#fff", fontSize: 15, marginBottom: 8 }}>Cancel your subscription?</p>
                                <p style={{ color: "rgba(255,255,255,0.5)", fontSize: 12, marginBottom: 24 }}>
                                    You will retain access until the end of your current billing period. This action cannot be undone.
                                </p>
                                <div style={{ display: "flex", gap: 12, justifyContent: "flex-end" }}>
                                    <button onClick={() => setShowConfirm(false)} style={btnStyle}>Keep Subscription</button>
                                    <button onClick={handleUnsubscribe} disabled={busy} style={{ ...btnStyle, background: "#e57373", color: "#fff", opacity: busy ? 0.6 : 1 }}>
                                        {busy ? "..." : "Unsubscribe"}
                                    </button>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            )}

            <LegalModals>
                {({ setShowTerms, setShowCookie, setShowDNS }) => (
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: 20, fontSize: 12 }}>
                        <button onClick={() => setShowTerms(true)} style={linkStyle}>Terms & Policy</button>
                        <button onClick={() => setShowCookie(true)} style={linkStyle}>Cookie Policy</button>
                        <button onClick={() => setShowDNS(true)} style={linkStyle}>Do Not Sell My Info</button>
                        {user && user.subscription?.active && user.role !== "admin" && (
                            <button data-testid="unsubscribe-btn" onClick={() => { setShowConfirm(true); setMsg(""); }} style={linkStyle}>
                                Unsubscribe
                            </button>
                        )}
                    </div>
                )}
            </LegalModals>
        </footer>
    );
}

const linkStyle = {
    color: "var(--pord-teal, #9aada8)", textDecoration: "none", fontSize: 12,
    background: "none", border: "none", cursor: "pointer", fontFamily: "'DM Sans', sans-serif", padding: 0,
};
const btnStyle = {
    padding: "8px 18px", borderRadius: 8, fontSize: 13, cursor: "pointer",
    background: "rgba(184,212,208,0.08)", border: "1px solid rgba(184,212,208,0.15)",
    color: "#DAF2D0", fontFamily: "'DM Sans', sans-serif",
};
